import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const classicBusinessProformaIssueFormsDirectEmbedRoute: InvariantJiraRoute = {
	name: 'classic-business-proforma-issue-forms-direct-embed',
	path: '/jira/core/projects/:projectKey/forms/form/direct/:templateFormId/:issueTypeId?/embed',
	exact: true,
};
